/* @generated from adl module ferovinum.sourcecontracts.expensesettlement */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.expense_settlement` contract.
 */
export interface ExpenseSettlementSource {
  id: common_strings.StringNE;
  expenseId: ferovinum_app_db.ExpenseId;
  settlementMethod: common_strings.StringNE;
  capexDescriptionId: (ferovinum_app_db.CapitalisedExpenseDescriptionId|null);
  invoiceLineItemId: (ferovinum_app_db.InvoiceLineItemId|null);
  purchaseRequestId: (ferovinum_app_db.PurchaseRequestId|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeExpenseSettlementSource(
  input: {
    id: common_strings.StringNE,
    expenseId: ferovinum_app_db.ExpenseId,
    settlementMethod: common_strings.StringNE,
    capexDescriptionId: (ferovinum_app_db.CapitalisedExpenseDescriptionId|null),
    invoiceLineItemId: (ferovinum_app_db.InvoiceLineItemId|null),
    purchaseRequestId: (ferovinum_app_db.PurchaseRequestId|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): ExpenseSettlementSource {
  return {
    id: input.id,
    expenseId: input.expenseId,
    settlementMethod: input.settlementMethod,
    capexDescriptionId: input.capexDescriptionId,
    invoiceLineItemId: input.invoiceLineItemId,
    purchaseRequestId: input.purchaseRequestId,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const ExpenseSettlementSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.expensesettlement","decl":{"annotations":[{"value":{"modelName":"source__app_db.expense_settlement","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.expense_settlement` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseId","default":{"kind":"nothing"},"name":"expenseId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}},{"annotations":[],"serializedName":"settlementMethod","default":{"kind":"nothing"},"name":"settlementMethod","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"capexDescriptionId","default":{"kind":"nothing"},"name":"capexDescriptionId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CapitalisedExpenseDescriptionId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"invoiceLineItemId","default":{"kind":"nothing"},"name":"invoiceLineItemId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InvoiceLineItemId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"purchaseRequestId","default":{"kind":"nothing"},"name":"purchaseRequestId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequestId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ExpenseSettlementSource","version":{"kind":"nothing"}}};

export const snExpenseSettlementSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.expensesettlement", name:"ExpenseSettlementSource"};

export function texprExpenseSettlementSource(): ADL.ATypeExpr<ExpenseSettlementSource> {
  return {value : {typeRef : {kind: "reference", value : snExpenseSettlementSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.expensesettlement.ExpenseSettlementSource" : ExpenseSettlementSource_AST
};
